import React from 'react';
import { SectionPanel, Textarea, ValidationLevel } from 'ui';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { MetroLineSection } from 'app/components/metro-line/metro-line-section';
import { FavouriteSectionType } from '../metroline/types';
import { FavouriteFormIds, maxLengthOfEmailsInputValue } from '../constants';
import { FavouriteSection } from '../types';
import { isValidListOfEmails } from 'app/infrastructure/validation/email';
import { displayRecipientsSection } from 'app/area/favourite-administration/form/components/helpers';

export const FavouriteRecipients: React.FC<FavouriteSection> = ({
  favouriteItem, section, validation, translation, updateItem, getRef, shouldRenderSection
}) => {

  if (!displayRecipientsSection(favouriteItem)) {
    return null;
  }

  const onTemplateTextChange = (value: string) => {
    updateItem({ [FavouriteFormIds.emailSubscribers]: value.trim() });
  };

  const [invalidEmail, setInvalidEmail] = React.useState(false);
  const errorParamsRequired = {
    level: ValidationLevel.error,
    messages: [{ level: ValidationLevel.error, message: translation.invalid_email_error }]
  };

  const emailValidation = !!favouriteItem?.emailSubscribers && invalidEmail
    && !isValidListOfEmails(favouriteItem?.emailSubscribers) && errorParamsRequired;

  const onBlurEmail = (): boolean => {
    if (!isValidListOfEmails(favouriteItem?.emailSubscribers)) {
      setInvalidEmail(true);
      return false;
    }
    setInvalidEmail(false);
    return true;
  };

  return <MetroLineSection<FavouriteSectionType>
    section={section}
    sectionType={FavouriteSectionType.Recipients}
    getRef={getRef}
    shouldRenderSection={shouldRenderSection}>
    <div ref={getRef(FavouriteSectionType.Recipients)}>
      <SectionPanel
        className="admin-paper-top-panel"
        componentId={FavouriteSectionType.Recipients}
        validation={undefined}
        info={{ text: translation.recipients }}
        label={{ visible: true, text: translation.recipients }} />
      <MainGridContainer>
        <div className="row mb-4">
          <div className="col-12">
            <Textarea
              componentId={FavouriteFormIds.emailSubscribers}
              value={favouriteItem?.emailSubscribers}
              label={{ text: translation.recipients_title }}
              maxLength={maxLengthOfEmailsInputValue}
              placeholder={translation.recipients_placeholder}
              onBlur={onBlurEmail}
              onChange={onTemplateTextChange}
              validation={{ ...validation.emailSubscribers, ...emailValidation }} />
          </div>
        </div>
      </MainGridContainer>
    </div>
  </MetroLineSection>;
};
